"use strict";

import helpers from "./_helpers";

const Forms = () => {
    const init = () => {
        $(document).ready(function () {

            initializeNiceSelects();

            // Enable focus states
            $(document).on('click.nice_select', function(event) {
                $('.nice-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.nice-select').length !== 0) {
                    $(event.target).closest('.nice-select').parents('.form-group').addClass('focused');
                }
            });
            // Refresh form on change
            $(document).on('click','.js-refresh-on-click', function (e) {
                e.preventDefault();
                $(this).parent().find('.js-refresh-on-click').removeClass('active');
                $(this).addClass('active');
                $(this).parents('form').find('.js-current-page').val(1);
                helpers.setUrlParameter($(this).data('filter-type'), $(this).data('value'));
                helpers.setUrlParameter('page', 1);
                $(this).parents('form').find('.js-ajax-submit').trigger('click');
            });
            $(document).on('change','.js-refresh-on-change', function (e) {
                e.preventDefault();
                $(this).parents('form').find('.js-current-page').val(1);
                helpers.setUrlParameter($(this).data('filter-type'), $(this).val());
                helpers.setUrlParameter('page', 1);
                $(this).parents('form').find('.js-ajax-submit').trigger('click');
            });

            $(document).on('click','.js-clear-kit-homes-filters', function (e) {
                e.preventDefault();
                var $form = $('.js-floorplan-filter-form');

                $form.find('.js-multiple-filter[data-value=""]').each(function() {
                    setMultiFilter($(this), $form);
                });
                $form.find('.js-refresh-on-change').each(function() {
                    $(this).val('');
                });
                $form.find('.js-current-page').val(1);
                helpers.setUrlParameter('page', 1);
                $form.find('.js-ajax-submit').trigger('click');
                $('.js-kit-home-filter-list').find('.js-module-kit-homes-filter-sidebar').removeClass('open');
            });

            $(document).on('click','.js-multiple-filter', function (e) {
                e.preventDefault();

                if($(this).hasClass('disabled')) {
                    return;
                }

                var $form = $(this).parents('form');

                setMultiFilter($(this), $form);

                if(!$form.hasClass('js-redirect-form')) {
                    $(this).parents('form').find('.js-current-page').val(1);
                    helpers.setUrlParameter('page', 1);
                    $(this).parents('form').find('.js-ajax-submit').trigger('click');
                }
            });

            $(document).on('click','.js-submit-redirect-form', function (e) {
                e.preventDefault();

                // redirect form to search resutls page
                var $form = $(this).parents('form');

                var url = $form.attr('data-redirect-url') + '?page=1' +
                    '&bathrooms=' + $form.find('.js-kit-home-filter-bathrooms').val() +
                    '&bedrooms=' + $form.find('.js-kit-home-filter-bedrooms').val() +
                    '&house_areas=' + $form.find('.js-kit-home-filter-house_areas').val() +
                    '&price=' + $form.find('.js-kit-home-filter-price').val();

                window.location.href = url;
            });

            // Close nice select on click
            $('.nice-select ul li').click(function () {
                setTimeout(function () {
                    $('.nice-select').removeClass("open");
                }, 10);
            });

            $("input[type='date']").parent().addClass('date-field');
            /**
             * Handle input focus to animate labels
             */
            $('input, textarea').each(function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled').removeClass('has-error');
                    $(this).parents('.form-group').find('.help-block.form-field-error-label').hide();
                }
            });

            $(document).on('focus','input, textarea', function (e) {
                $(this).parents('.form-group').addClass('focused');
            });

            $(document).on('blur','input, textarea, select', function (e) {
                var inputValue = $(this).val();
                $(this).parents('.form-group').removeClass('focused');
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled').removeClass('has-error');
                    $(this).parents('.form-group').find('.help-block.form-field-error-label').hide();
                }
            });

            $(document).on('change','input[type="radio"]', function (e) {
                if ($('input[name=' + $(this).attr('name') + ']:checked').length > 0) {
                    $(this).parents('.form-group').addClass('filled').removeClass('has-error');
                    $(this).parents('.form-group').find('.help-block.form-field-error-label').hide();
                } else {
                    $(this).parents('.form-group').removeClass('filled');
                }
            });

            $(document).on('change','select', function (e) {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled').removeClass('has-error');
                    $(this).parents('.form-group').find('.help-block.form-field-error-label').hide();
                }
            });

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                $(this).parents('.form-group').removeClass('focused');
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('.nice-select').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                $(this).niceSelect('update');
            })

            // Make all 'disabled' values actually disabled - not available in form builder
            $("option:selected").each(function () {
                let $option = $(this);
                if ($option.val() === 'disabled') {
                    $option.attr('disabled', true);
                    $option.attr('selected', true);
                }
            });

            // Add '*' to required fields
            $('input:required, select:required, textarea:required').each(function () {
                let $label = $(this).parents('.form-group').find('label');
                $label.addClass('required');
            });

            $(document).on('change','.js-kithome-selector', function (e) {
                var inputValue = $(this).val();
                var floorplan_data = JSON.parse('{'+$(this).attr('data-kithome-floorplan-mapping')+'}');
                var $floorplan_dropdown_group = $(this).parents('form').find('.js-floorplan-group-selector');
                $floorplan_dropdown_group.removeClass('filled');
                var $select = $floorplan_dropdown_group.find('.nice-select');

                $select.empty();
                $select.append($('<option></option>').val($select.attr('data-default-placeholder')).text($select.attr('data-default-placeholder')));

                if (inputValue == "") {
                    $floorplan_dropdown_group.addClass('disabled');
                } else {
                    $floorplan_dropdown_group.removeClass('disabled');
                    // Check if key exists in data
                    if (floorplan_data[inputValue]) {
                        // Add new options
                        floorplan_data[inputValue].forEach(option => {
                            $select.append($('<option></option>').val(option).text(option));
                        });
                    }
                }
                $select.niceSelect('update');
            });
        });

        //////////////////////////////////////////////
        // Paginate Hook
        //////////////////////////////////////////////
        // Listen for ajax success events & jump the page to the results
        $(document).ajaxSuccess(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    if($(window).scrollTop() > 0){
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top - 220
                        }, 100);
                    }
                    paginateHook();
                }
                onSuccess(xhr.target);
            }
        });
        $(document).ajaxError(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    if($(window).scrollTop() > 0){
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top - 220
                        }, 100);
                    }
                    paginateHook();
                }
                onError(xhr.target);
            }
        });

        window.initializeNiceSelects = function(){
            // Enable niceselect on nice-selected dropdowns
            $('select.nice-select').each(function () {
                const $select = $(this); // Reference the current <select> element

                // Initialize Nice Select for this element
                $select.niceSelect();

                // Add classes to the Nice Select dropdown items for this <select>
                $select.find('option').each(function (index) {
                    const optionClass = $(this).attr('class'); // Get the class from the <option>
                    if (optionClass) {
                        // Add the class to the corresponding dropdown item
                        $select.next('.nice-select').find('.list .option').eq(index).addClass(optionClass);
                    }
                });

                // Disable items based on the "disabled" class
                $select.next('.nice-select').find('.list .option.disabled').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
        }

        function getParam(name, url) {
            if (!url)
                url = location.href;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results === null ? null : results[1];
        }

        function paginateHook() {
            // Duplicate pagination to outside of reload area
            $("#move-pagination-target").html($('#move-pagination-js').html());
            $('.pagination a').on('click', function (e) {
                e.preventDefault();
                var page = getParam('page', $(this).attr('href'));
                helpers.setUrlParameter('page', page);
                var form = $(this).parents('.js-pagination').attr('data-form');
                $(form).find('.js-current-page').val(page);
                $(form).find('.js-ajax-submit').trigger('click');
            });
        }

        // Checkbox auto refresh
        $('.filter-container input[type=checkbox]').change(function() {
            $(this).parents('form').find('.js-current-page').val(1);
            $(this).parents('form').find('.js-ajax-submit').trigger('click');
        });

        paginateHook();


    };

    const setMultiFilter = ($filter, $form) => {
        if($filter.data('value') == '') {
            $filter.parent().find('.js-multiple-filter').removeClass('active').removeClass('disabled');
            $filter.addClass('active');
        } else {
            if ($filter.hasClass('active')) {
                $filter.removeClass('active');
                if ($filter.parent().find('.js-multiple-filter.active').length == 0) {
                    $filter.parent().find('.js-multiple-filter[data-value=""]').addClass('active');
                }
            } else {
                $filter.parent().find('.js-multiple-filter[data-value=""]').removeClass('active');
                $filter.addClass('active');
            }
        }

        var filter_options = [];
        $filter.parents('.form-group').find('.js-multiple-filter.active').each(function() {
            filter_options.push($(this).data('value'));
        });

        $form.find('.js-kit-home-filter-' + $filter.data('filter-type')).val(filter_options.toString());

        if(!$form.hasClass('js-redirect-form')) {
            helpers.setUrlParameter($filter.data('filter-type'), filter_options.toString());
        }
    }

    const onSuccess = (form) => {
        $(form).find('.alert-success:not(.alert-full-success)').addClass('show');
        $(form).find('.alert-danger').removeClass('show');
        $(form).find('.js-validate-button').prop('disabled', false);
        if($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).offset().top - 150
            }, 200);
        }
    };

    const onFullSuccess = (form, data) => {
        var $form = $(form);
        if (data['X_OCTOBER_REDIRECT']) {
            window.location.href = data['X_OCTOBER_REDIRECT'];
        } else {
            $('form').removeClass('oc-loading');
            $('body').removeClass('oc-loading');
            $('.stripe-loading-indicator').addClass('loaded');

            if($form.hasClass('form-code-quote-form-step-one')) {
                // Show step 2
                showStepTwo($form);
                GA.onFormSuccess(form);
                GA.onQuoteFormStepOneFormSuccess(form);

                $form.find('.alert-success').removeClass('show');
                $form.find('.alert-danger').removeClass('show');
            } else if($form.hasClass('form-code-quote-form-step-two')) {
                // Show step 3 but also reset as they submitted the form
                showStepThree($form);

                GA.onFormSuccess(form);
                GA.onQuoteFormStepTwoFormSuccess(form);

                // Reset quote 2 form
                $form[0].reset();
                $form.find('.focused, .filled').removeClass('focused').removeClass('filled');
                $form.find('.nice-select .current').empty();
                $form.find('.js-no-dimensions').prop('checked', false);
                $form.find('.js-no-dimensions-field').removeAttr('style').removeClass('not-required');
                $form.find('.js-floorplan-option-field').val('');
                $form.find('.alert-success').removeClass('show');
                $form.find('.alert-danger').removeClass('show');

                // Reset quote 1 form
                var module_wrapper = $form.parents('.js-quote-form-container');
                module_wrapper.find('[data-form-id="quote-form-step-one"]')[0].reset();
                module_wrapper.find('[data-form-id="quote-form-step-one"]').find('.focused, .filled').removeClass('focused').removeClass('filled');
                module_wrapper.find('[data-form-id="quote-form-step-one"]').find('.nice-select .current').empty();
            } else if($form.hasClass('form-code-quote-form-single-step') ||
                $form.hasClass('form-code-checkout-form') ||
                $form.hasClass('form-code-quote-form-single-step-product-variant'))
            {
                showStepThree($form);

                GA.onFormSuccess(form);
                GA.onQuoteFormStepTwoFormSuccess(form);

                // Reset form
                $form[0].reset();
                $form.find('.focused, .filled').removeClass('focused').removeClass('filled');
                $form.find('.nice-select .current').empty();

                $form.find('.js-floorplan-group-selector').addClass('disabled');

                var $select = $form.find('.js-floorplan-group-selector .nice-select')
                $select.empty();
                $select.append($('<option></option>').val($select.attr('data-default-placeholder')).text($select.attr('data-default-placeholder')));
                $select.niceSelect('update');

                $form.find('.alert-success').removeClass('show');
                $form.find('.alert-danger').removeClass('show');
            } else {
                // Normal form submission
                GA.onFormSuccess(form);

                if(data.download && data.download.length > 0) {
                    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                        $('.js-popout').removeClass('open');
                        $('.js-popout[data-hash="download-popout"] .js-download-link').attr('href', data.download);
                        $('.js-popout[data-hash="download-popout"]').addClass('open');
                    }else{
                        var $link = $('<a href="'+data.download+'" target="_blank"></a>');
                        $('body').append($link);
                        $link[0].click();
                    }
                }
                $form[0].reset();
                $form.find('.focused, .filled').removeClass('focused').removeClass('filled');
                $form.find('.nice-select .current').empty();
            }
            var count = 0;
            $(form).find('.js-validate-button').prop('disabled', false);
            $('.g-recaptcha').each(function () {
                grecaptcha.reset(count);
                count++;
            });
        }

        $form.find('.alert-full-success').addClass('show');
        $form.find('.alert-success:not(.alert-full-success)').removeClass('show');
        $form.find('.alert-danger').removeClass('show');
        if($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $form.offset().top - 100
            }, 200);
        }
    };

    const onError = (form, data) => {
        var $form = $(form);
        var count = 0;
        $('.g-recaptcha').each(function () {
            grecaptcha.reset(count);
            count++;
        });

        var module_wrapper = $form.parents('.js-quote-form-container');
        if(module_wrapper.length) {
            if(module_wrapper.find('.js-quote-form-inner-container').length) {
                module_wrapper.find('.js-quote-form-inner-container').height($form.outerHeight() + 40);
            }
        }

        $(form).find('.alert-danger').addClass('show');
        $(form).find('.alert-success').removeClass('show');
        $(form).find('.js-validate-button').prop('disabled', false);
        
        if($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).offset().top - 150
            }, 200);
        }

        if (data['X_OCTOBER_ERROR_FIELDS']) {
            var isFirst = true;
            for (var field_name in data['X_OCTOBER_ERROR_FIELDS']){
                var $input = $form.find('[name="' + field_name + '"]')
                var $field_group = $input.closest('.form-group');

                if (!$field_group.length) {
                    return;
                }

                let $help = $('<p />').addClass('form-field-error-label');

                if (data['X_OCTOBER_ERROR_FIELDS'][field_name]) {
                    var message = data['X_OCTOBER_ERROR_FIELDS'][field_name];
                    if(Array.isArray(data['X_OCTOBER_ERROR_FIELDS'][field_name])) {
                        message = data['X_OCTOBER_ERROR_FIELDS'][field_name][0];
                    }
                    $help.text(message);
                }

                $field_group.addClass('has-error');

                if ($('.form-field-error-label', $field_group).length > 0) {
                    return;
                }

                $field_group.append($help);

                if (isFirst) {
                    $input.focus();
                }
                isFirst = false
            }
        }
    };

    return {
        init: init,
        onSuccess: onSuccess,
        onFullSuccess: onFullSuccess,
        onError: onError
    };
};

export default Forms;